import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { LocalStorageService } from '../shared/services/local-storage.service';
import { catchError, map, of, tap, timer } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';

let infoLoaded = false;

export const authGuard: CanActivateFn = (route, state) => {
  const apiService = inject(ApiService);
  const lsService = inject(LocalStorageService);
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);
  const router = inject(Router);

  if (infoLoaded) {
    const role = lsService.getItem('role');
    if (role !== 'manager' && role !== 'subagency_manager') {
      router.navigate(['/']);
      return of(false);
    }
    return of(true);
  }

  return apiService.getAccountInfo().pipe(
    tap(result => {
      infoLoaded = true;

      lsService.setItem('role', result.role);
      lsService.setBool('isConsumerOwner', result.is_consumer_owner);
      lsService.setItem('email', result.email);
      lsService.setBool('agencyStatus', result.agency_status);
      lsService.setBool('isSuperagency', result.is_superagency);
      lsService.setItem('agency', result.agency);
      lsService.setItem('agencyID', result.agency_id);
      lsService.setItem('rbac', JSON.stringify(result.rbac));
    }),
    map(result => {
      authService.isUserDataReceived.next(true);
      if (result.role !== 'manager' && result.role !== 'subagency_manager') {
        toastr.warning('Access denied: Only agency managers are allowed.', 'Unauthorized Role', {
          timeOut: 0,
          extendedTimeOut: 0,
          tapToDismiss: false,
        });
        router.navigate(['/']);
        return false;
      }
      return true;
    }),
    catchError(err => {
      console.error('Failed to load account info', err);
      lsService.clear();
      authService.isUserDataReceived.next(false);
      return of(true);
    })
  );
};
